import { TrackingProvider } from '@act/react-components/tracking';
import {
  FlexContainer,
  ReemaThemeV2,
  ToggleSwitch,
  useDisplayModeContext,
} from '@act/storybook';
import { FullScreenDialog } from '@act/toolkit/styles/fullScreenDialogComponents';
import { useMobile } from '@act/utilities/mobile-context';
import { Box } from '@mui/material';
import { useState } from 'react';

const CALL_FORM_VIEW = 'callForm';
const GOALS_VIEW = 'goals';

export const CallFullScreen = ({
  open,
  handleClose,
  leftContent,
  rightContent,
  topContent,
  drawerIsOpen,
}: {
  open: boolean;
  handleClose: () => void;
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  topContent?: React.ReactNode;
  drawerIsOpen?: boolean;
}) => {
  const { displayMode } = useDisplayModeContext();
  const { isMobile } = useMobile();
  const [selectedSection, setSelectedSection] = useState(CALL_FORM_VIEW);

  return (
    <TrackingProvider contextName="call-fullscreen">
      <FullScreenDialog
        open={open}
        onClose={() => handleClose()}
        displayMode={displayMode}
        noElevation={true}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            width: '100%',
            position: 'relative',
            overflow: 'hidden',
            marginTop: 0,
            ...(isMobile
              ? {
                  backgroundColor:
                    selectedSection === CALL_FORM_VIEW
                      ? ReemaThemeV2.LIGHT_MODE.palette.neutralLight.main
                      : ReemaThemeV2.LIGHT_MODE.palette.creamShades[10],
                }
              : {
                  background: `linear-gradient(to right, ${ReemaThemeV2.LIGHT_MODE.palette.neutralLight.main} 0%, ${ReemaThemeV2.LIGHT_MODE.palette.neutralLight.main} 50%, ${ReemaThemeV2.LIGHT_MODE.palette.creamShades[10]} 50%, ${ReemaThemeV2.LIGHT_MODE.palette.creamShades[10]} 100%)`,
                }),
          }}
        >
          <Box>{topContent}</Box>
          {isMobile && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexShrink: 0,
                marginTop: '128px !important',
              }}
            >
              <ToggleSwitch
                options={[
                  { label: 'Call form', value: CALL_FORM_VIEW },
                  { label: 'Goals', value: GOALS_VIEW },
                ]}
                value={selectedSection}
                onChange={setSelectedSection}
              />
            </Box>
          )}
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              overflow: 'hidden',
              marginTop: 1,
            }}
          >
            {(!isMobile || selectedSection === CALL_FORM_VIEW) && (
              <FlexContainer
                direction="column"
                alignItems="center"
                gap={2}
                padding={isMobile ? 1 : 0}
                width={isMobile ? '100%' : '50%'}
                backgroundColor={
                  ReemaThemeV2.LIGHT_MODE.palette.neutralLight.main
                }
              >
                {leftContent}
              </FlexContainer>
            )}
            {(!isMobile || selectedSection === GOALS_VIEW) && (
              <Box
                sx={{
                  gap: 12,
                  width: isMobile ? '100%' : '50%',
                  backgroundColor:
                    ReemaThemeV2.LIGHT_MODE.palette.creamShades[10],
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: isMobile ? 'flex-start' : 'flex-end',
                  overflow: 'hidden',
                  boxSizing: 'border-box',
                  minHeight: '100%',
                  position: 'relative',
                  ...(!drawerIsOpen ? { padding: 3 } : {}),
                }}
              >
                {rightContent}
              </Box>
            )}
          </Box>
        </Box>
      </FullScreenDialog>
    </TrackingProvider>
  );
};
